import React from 'react';
import { X } from 'lucide-react';

const RoleModal = ({ isOpen, onClose, onSave, role, setRole, isEditing, t }) => {
    if (!isOpen) return null;

    const togglePermission = (module, action) => {
        setRole(prev => ({
            ...prev,
            permissions: {
                ...prev.permissions,
                [module]: { ...prev.permissions[module], [action]: !prev.permissions[module][action] }
            }
        }));
    };

    return (
        <div className="profile-modal-overlay" onClick={onClose}>
            <div className="card glass" style={{ maxWidth: '640px', width: '100%', padding: '2rem' }} onClick={e => e.stopPropagation()}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2rem' }}>
                    <h2 style={{ fontWeight: 800 }}>{isEditing ? t('roles.editRole') : t('roles.addRole')}</h2>
                    <button onClick={onClose} style={{ background: 'transparent' }}><X size={24} /></button>
                </div>
                <form onSubmit={onSave}>
                    <div style={{ marginBottom: '1.5rem' }}>
                        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600 }}>{t('roles.roleName')}</label>
                        <input required value={role.name} onChange={e => setRole({ ...role, name: e.target.value })} />
                    </div>
                    <div style={{ maxHeight: '400px', overflowY: 'auto', marginBottom: '2rem' }}>
                        {Object.entries(role.permissions).map(([module, perms]) => (
                            <div key={module} style={{ marginBottom: '1rem', padding: '1rem', background: 'var(--bg-main)', borderRadius: '12px' }}>
                                <div style={{ fontWeight: 800, fontSize: '0.75rem', color: 'var(--primary)', marginBottom: '0.5rem' }}>{module.toUpperCase()}</div>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                                    {Object.keys(perms).map(action => (
                                        <label key={action} style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.8rem' }}>
                                            <input type="checkbox" checked={perms[action]} onChange={() => togglePermission(module, action)} />
                                            {action}
                                        </label>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div style={{ display: 'flex', gap: '1rem' }}>
                        <button type="button" onClick={onClose} className="btn-secondary" style={{ flex: 1 }}>İptal</button>
                        <button type="submit" className="btn-primary" style={{ flex: 1 }}>Kaydet</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default RoleModal;
